/* lua.js generated code 0.3.0 */

require("clover/panel/component/common/uiGroupButtonLayout/UIGLabelButton")
require("clover/panel/component/common/uiGroupButtonLayout/UIGIconDiscountLabelButton")
var MarkPriseWxChestPanel = xClass("MarkPriseWxChestPanel", BasePanel, function () {
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/mark_panel_prise_panel.csb")
})
var MarkPriseWxChestPanelEvent = table(
    [1, "Close", "MARKPRISEPANELEVENT.CLOSE"],
    [1, "Buy", "MARKPRISEPANELEVENT.BUY"],
    [1, "TimeUp", "MARKPRISEPANELEVENT.TIMEUP"],
    [1, "Get", "MARKPRISEPANELEVENT.GET"]
)
let preload_res = []
let extra_plist = "cocos/mark_panel.plist"
MarkPriseWxChestPanel.asyncCreate = function (info, _callback) {
    function callback() {
        var panel = MarkPriseWxChestPanel.create(info)
        _callback(panel)
    }
    function onFail() {
        Toast.make(getText("error.tip.timeout"))
    }
    preload_res = ["packed/MarkPriseWxPreloadConfig.pack"];
    if (!cc.loader.getRes(getRealResourceName(extra_plist))) {
        preload_res.push(extra_plist)
    }
    preloadWithLoading(preload_res, callback, onFail)
}
MarkPriseWxChestPanel.prototype.ctor = function (info) {
    var self = this
    self.info = clone(info)
    BasePanel.prototype.ctor.call(self)
    self.buildUI()
}
MarkPriseWxChestPanel.prototype.buildUI = function () {
    var self = this
    var title = self.getChildByName("title")
    title.setString(getText("mark.prise.wx.chest.panel.title"))
    var size = title.getContentSize()
    var bg = self.getChildByName("bg")
    title.setPositionX(bg.getPositionX() + (bg.getContentSize().width - size.width) / 2)
    var desc = self.getChildByName("desc")
    var newDesc = cc.Label.create(getText("mark.prise.wx.chest.panel.desc"), "Arial", 30)
    newDesc.setAnchorPoint(cc.p(0, 1))
    newDesc.setColor(cc.color(117, 64, 46, 85))
    newDesc.setScale(1.2)
    newDesc.setAlignment(cc.TEXT_ALIGNMENT_CENTER)
    var size = newDesc.getContentSize()
    newDesc.setPosition((bg.getContentSize().width - size.width * newDesc.getScale()) / 2, -470)
    self.addChild(newDesc)
    desc.removeFromParent(true)

    if (self.info.canFetch) {
        newDesc.setString(getText("mark.prise.wx.chest.panel.success.desc"))
        newDesc.x -= 20
    }

    var close = UIGroupButton.create(self.getChildByName("close"))
    PushBounceAnim.create(close)
    close.on(UIButtonEvent.Click, function () {
        self.dispatchEvent(table([1, "name", MarkPriseWxChestPanelEvent.Close]))
    })

    let newBtn = cc.CSLoader.createNode("cocos/mark_panel_bottom_btn_green_start.csb")
    let oldBtn = self.getChildByName("btn")
    let newBtnPos = oldBtn.getPosition()
    newBtnPos.y -= 25
    newBtn.setPosition(newBtnPos)
    newBtn.setAnchorPoint(oldBtn.getAnchorPoint())
    self.addChild(newBtn)
    oldBtn.removeFromParent(true)
    self.button = UIGLabelButton.create(newBtn)
    self.button.x = self.width / 2 + 5
    if (self.info.canFetch) {
        self.button.setString("领取")
        DCAssist.dc4ShareShow("mark");
    } else {
        self.button.setString("求助好友")
    }
    // self.button.getChildByName("label").setFntFile("font/zzgftongxin_40_greenstroke.fnt")
    
    PushBounceIdleBubbleAnim.create(self.button)
    self.button.on(UIButtonEvent.Click, function () {
        if (self.info.canFetch) {
            self.dispatchEvent(table([1, "name", MarkPriseWxChestPanelEvent.Get]))
        } else {
            self.dispatchEvent(table([1, "name", MarkPriseWxChestPanelEvent.Buy]))
        }
    })
    
    var leaf = self.getChildByName("leaf")
    leaf.setLocalZOrder(20)
    var box = self.getChildByName("box")
    box.setLocalZOrder(10)
    var anim = cc.CSLoader.createTimeline("cocos/mark_panel_res_box.csb")
    box.runAction(anim)
    box.anim = anim
    for (let i = 1, v = self.info.props[1]; v; i++, v = self.info.props[i]) {
        var sprite = UIItemBuilder.createProp(v.itemId, v.num)[0]
        sprite.setName("prop")
        sprite.itemId = v.itemId
        sprite.num = v.num
        var sSize = sprite.getContentSize()
        var item = box.getChildByName("item" + tostring($len(self.info.props)) + "_" + tostring(i))
        if (!item) {
            break
        }
        var phSize = item.getContentSize()
        sprite.setScale(phSize.width * item.getScaleX() / sSize.width * 1.2)
        sprite.setPosition(cc.p(phSize.width / 2, phSize.height / 2))
        item.addChild(sprite, 10)
        if (i % 2 !== 0) {
            sprite.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.Spawn.create(cc.MoveBy.create(0.7917, cc.p(0, -15)), cc.RotateTo.create(0.7917, -5.0003)), cc.Spawn.create(cc.MoveBy.create(1.4583, cc.p(0, 30)), cc.RotateTo.create(1.4583, 2.9995)), cc.Spawn.create(cc.MoveBy.create(0.8333, cc.p(0, -15)), cc.RotateTo.create(0.8333, -2.7614)))))
        } else {
            sprite.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.Spawn.create(cc.MoveBy.create(1.2083, cc.p(0, -17)), cc.RotateTo.create(1.2083, -5.0003)), cc.Spawn.create(cc.MoveBy.create(1.4583, cc.p(0, 32)), cc.RotateTo.create(1.4583, 2.9995)), cc.Spawn.create(cc.MoveBy.create(1.4583, cc.p(0, -34)), cc.RotateTo.create(1.4583, 5.0003)), cc.Spawn.create(cc.MoveBy.create(1.25, cc.p(0, 19)), cc.RotateTo.create(1.25, -2.7614)))))
        }
    }

    var bg = self.getChildByName("bg")
    var timeText = self.getChildByName("time")

    if (self.info.canFetch) { // 可以领取时不显示倒计时
        timeText.removeFromParent(true)
    } else {
        timeText.setScale(0.8)
        timeText.y -= 20
        function refresh() {
            var time = Math.max(self.info.endTime - Localhost.time(), 0)
            timeText.setString(UIUtils.formatTime(time))
            timeText.setPositionX((bg.getContentSize().width - timeText.getContentSize().width * timeText.getScale()) / 2)
            if (time <= 0) {
                self.button.setEnabled(false)
                self.dispatchEvent(table([1, "name", MarkPriseWxChestPanelEvent.TimeUp]))
            }
        }
        refresh()
        self.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.DelayTime.create(0.5), cc.CallFunc.create(refresh))))
    }
    var size = bg.getContentSize()
    self.setContentSize(cc.size(size.width, size.height - bg.getPositionY()))
    self.setScale(self.getReferenceScale())
}
MarkPriseWxChestPanel.prototype.playPropAnim = function (finishCallback) {
    var self = this
    var box = self.getChildByName("box")
    var items = table()
    for (let i = 1; i <= 3; i += 1) {
        var $limit42 = i
        for (let j = 1; j <= $limit42; j += 1) {
            table.insert(items, box.getChildByName("item" + tostring(i) + "_" + tostring(j)))
        }
    }
    for (let i = 1, v = items[1]; v; i++, v = items[i]) {
        let prop = v.getChildByName("prop")
        if (prop) {
            prop.runAction(cc.Sequence.create(cc.Spawn.create(cc.ScaleBy.create(0.1, 0.5), he.GroupRenderPassAction.create(0.1, table([0, table([1, "shader", "brightness"], [1, "u_brightness", table(0.0)])]), table([0, table([1, "shader", "brightness"], [1, "u_brightness", table(1.0)])]))), cc.CallFunc.create(function () {
                var glow = self.rewardItemGlowAnim()
                glow.setScale(0.5)
                glow.setPosition(cc.p(prop.getPosition()))
                v.addChild(glow, 5)
                glow.runAction(cc.Sequence.create(cc.Spawn.create(cc.ScaleTo.create(0.5, 1.7), cc.Sequence.create(he.GroupRenderPassAction.create(0.1, table([0, table([1, "shader", "brightness"], [1, "u_brightness", table(0.0)])]), table([0, table([1, "shader", "brightness"], [1, "u_brightness", table(0.8)])])), cc.DelayTime.create(0.16), cc.FadeOut.create(0.23))), cc.CallFunc.create(function () {
                    glow.removeFromParent(true)
                })))
            }), cc.Spawn.create(cc.ScaleBy.create(0.1, 2), he.GroupRenderPassAction.create(0.1, table([0, table([1, "shader", "brightness"], [1, "u_brightness", table(1.0)])]), table([0, table([1, "shader", "brightness"], [1, "u_brightness", table(0.0)])]))), cc.CallFunc.create(function () {
                prop.removeFromParent(true)

                if (prop.itemId === GamePropIds.kCoin) {
                    HomeSceneAnimation.playGetCoinAnimation(prop.num, v.convertToWorldSpace(cc.p(prop.getPosition())), 0.8, finishCallback)
                    return
                } else if (prop.itemId === GamePropIds.kCash) {
                    HomeSceneAnimation.playGetCashAnimation(prop.num, v.convertToWorldSpace(cc.p(prop.getPosition())), 0.8, finishCallback)
                    return
                }

                var config = table([0, table(
                        [1, "itemId", prop.itemId],
                        [1, "num", prop.num],
                        [1, "pos", v.convertToWorldSpace(cc.p(prop.getPosition()))]
                    )])
                PropBagAnimation.addItemsToBag(config, function () {
                    if (finishCallback) {
                        finishCallback()
                    }
                }, 0)
            })))
        }
    }
}
MarkPriseWxChestPanel.prototype.rewardItemGlowAnim = function () {
    var self = this
    var glow = cc.CSLoader.createNode("cocos/mark_panel_starglow.csb")
    var sprite1 = glow.getChildByName("glow1")
    sprite1.runAction(cc.RepeatForever.create(cc.RotateBy.create(1, 50)))
    var sprite2 = glow.getChildByName("glow2")
    sprite2.runAction(cc.RepeatForever.create(cc.RotateBy.create(1, -50)))
    var sprite3 = glow.getChildByName("glow3")
    sprite3.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.ScaleBy.create(25 / 30, 80 / 96), cc.ScaleBy.create(25 / 30, 96 / 80))))
    var sprite4 = glow.getChildByName("glow4")
    sprite4.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.ScaleBy.create(20 / 30, 96 / 80), cc.DelayTime.create(58 / 30), cc.ScaleBy.create(23 / 30, 80 / 96))))
    var nextAngle = math.random() * 160 + 10
    function genNewStar(star) {
        star.stopAllActions()
        star.setOpacity(255)
        star.setPosition(cc.p(0, 0))
        star.runAction(cc.Sequence.create(cc.Spawn.create(cc.RotateBy.create(1.6, math.random() * 40 + 20), cc.FadeOut.create(1.6), cc.MoveTo.create(1.6, cc.p(Math.cos(nextAngle * Math.PI / 180) * 75, Math.sin(nextAngle * Math.PI / 180) * 75))), cc.CallFunc.create(function () {
            genNewStar(star)
        })))
        nextAngle = nextAngle + math.random() * 160 + 10
    }
    for (let i = 1; i <= 18; i += 1) {
        var star = glow.getChildByName("star" + tostring(i))
        star.setPosition(cc.p(0, 0))
        if (star) {
            star.runAction(cc.Sequence.create(cc.DelayTime.create(1.6 / 18 * (i - 1)), cc.CallFunc.create(function () {
                genNewStar(star)
            })))
        } else {
            break
        }
    }
    return glow
}
MarkPriseWxChestPanel.prototype.popup = function (dark, canTouchBehind, posInWorld00, posInWorld11, callback) {
    var self = this
    if (posInWorld00 && posInWorld11) {
        // WARN: maybe multi result
        return self.popupWithPoint(dark, canTouchBehind, posInWorld00, posInWorld11, callback)
    } else {
        // WARN: maybe multi result
        return self.popupWithoutPoint(dark, canTouchBehind, callback)
    }
}
MarkPriseWxChestPanel.prototype.popupWithPoint = function (dark, canTouchBehind, position00, position11, callback) {
    var self = this
    var vSize = cc.Director.getInstance().getVisibleSize()
    var box = self.getChildByName("box")
    box.retain()
    PopoutManager.getInstance().addWithBgFadeIn(self, dark, canTouchBehind)
    var parent = self.getParent()
    var from = parent.convertToNodeSpace(cc.p((position00.x + position11.x) / 2, (position00.y + position11.y) / 2))
    box.setScaleX((position11.x - position00.x) / 177)
    box.setScaleY((position11.y - position00.y) / 151)
    var target = cc.p(box.getPosition())
    self.center()
    var to = self.convertToWorldSpace(cc.p(target.x, target.y))
    var leafSprite
    PanelScaleAnim.popup(self, 0.23, cc.p(vSize.width / 2, vSize.height / 2), 0, function () {
        var leaf = self.getChildByName("leaf")
        var wPos = self.convertToWorldSpace(cc.p(leaf.getPosition()))
        leafSprite = cc.Sprite.createWithSpriteFrameName("mark_panel/res_leaf.png")
        leafSprite.setScale(self.getScale() * leaf.getScale())
        leafSprite.setAnchorPoint(cc.p(0, 1))
        leafSprite.setPosition(wPos)
        parent.addChild(leafSprite, 100)
    })
    box.removeFromParent(false)
    parent.addChild(box)
    box.release()
    box.setPosition(from)
    box.runAction(cc.Sequence.create(cc.Spawn.create(cc.EaseSineOut.create(cc.MoveBy.create(0.6, cc.p((to.x - from.x) * self.getReferenceScale(), 0))), cc.EaseBackOut.create(cc.MoveBy.create(0.6, cc.p(0, to.y - from.y + 0))), cc.ScaleTo.create(0.6, 1)), cc.CallFunc.create(function () {
        box.retain()
        box.removeFromParent(false)
        box.setPosition(cc.p(target.x, target.y + 0))
        self.addChild(box)
        box.release()
        if (leafSprite) {
            leafSprite.removeFromParent(true)
        }
        self.onEnterAnimFinish()
        if (callback) {
            callback()
        }
    })))
    return self
}
MarkPriseWxChestPanel.prototype.popupWithoutPoint = function (dark, canTouchBehind, callback) {
    var self = this
    PopoutManager.getInstance().addWithBgFadeIn(self, dark, canTouchBehind)
    var vSize = cc.Director.getInstance().getVisibleSize()
    PanelScaleAnim.popup(self, 0.23, cc.p(vSize.width / 2, vSize.height / 2), 0, function () {
        self.onEnterAnimFinish()
        if (callback) {
            callback()
        }
    })
    return self
}
MarkPriseWxChestPanel.prototype.onEnterAnimFinish = function () {
    var self = this
    var box = self.getChildByName("box")
    box.anim.play("open", false)
    box.anim.setLastFrameCallFunc(function () {
        box.anim.clearLastFrameCallFunc()
        for (let i = 1; i <= 3; i += 1) {
            var star = box.getChildByName("star" + tostring(i))
            if (star) {
                star.runAction(cc.Sequence.create(cc.DelayTime.create(0.1 * (i - 1)), cc.CallFunc.create(function () {
                    star.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.FadeIn.create(0), cc.Spawn.create(cc.FadeOut.create(1.3), cc.MoveBy.create(1.3, cc.p(0, 27))), cc.MoveBy.create(0, cc.p(0, -27)))))
                })))
            }
        }
    })
}
MarkPriseWxChestPanel.prototype.onClickEmpty = function () {
    var self = this
    self.dispatchEvent(table([1, "name", MarkPriseWxChestPanelEvent.Close]))
}
MarkPriseWxChestPanel.prototype.onKeyBackClicked = function () {
    var self = this
    self.dispatchEvent(table([1, "name", MarkPriseWxChestPanelEvent.Close]))
}
MarkPriseWxChestPanel.prototype.onClose = function (posInWorld00, posInWorld11, finishCallback) {
    var self = this
    if (self.isClosed) {
        return 
    }
    self.isClosed = true
    self.remove(true, finishCallback, posInWorld00, posInWorld11)
}
MarkPriseWxChestPanel.prototype.remove = function (cleanup, callback, posInWorld00, posInWorld11) {
    var self = this
    if (posInWorld00 && posInWorld11) {
        self.removeWithAnim(cleanup, callback, posInWorld00, posInWorld11)
    } else {
        self.removeWithoutAnim(cleanup, callback)
    }
}
MarkPriseWxChestPanel.prototype.removeWithoutAnim = function (cleanup, callback) {
    var self = this
    self.onExitAnimStart()
    PopoutManager.getInstance().removeWithBgFadeOut(self, cleanup)
    var vSize = cc.Director.getInstance().getVisibleSize()
    PanelScaleAnim.remove(self, 0.2, cc.p(vSize.width / 2, vSize.height / 2), callback)
}
MarkPriseWxChestPanel.prototype.cleanup = function () {
    BasePanel.prototype.cleanup.call(this)
    let preload_list = buildResList(preload_res)
    unloadResList(preload_list)
    let index = preload_res.indexOf(extra_plist)
    if (index !== -1) {
        preload_res.splice(index,1)
    }
}
MarkPriseWxChestPanel.prototype.removeWithAnim = function (cleanup, callback, posInWorld00, posInWorld11) {
    var self = this
    var vSize = cc.Director.getInstance().getVisibleSize()
    var box = self.getChildByName("box")
    if (!box) {
        self.removeWithoutAnim(cleanup, callback)
        return 
    }
    var target = cc.p(box.getPosition())
    var from = cc.p(self.getPositionX() + target.x * self.getScaleX(), self.getPositionY() + target.y * self.getScaleY())
    var [scaleX, scaleY] = [(posInWorld11.x - posInWorld00.x) / 177, (posInWorld11.y - posInWorld00.y) / 151]
    var to = self.getParent().convertToNodeSpace(cc.p((posInWorld00.x + posInWorld11.x) / 2, (posInWorld00.y + posInWorld11.y) / 2))
    for (let i = 1; i <= 3; i += 1) {
        var star = box.getChildByName("star" + tostring(i))
        star.stopAllActions()
        star.runAction(cc.FadeOut.create(0.2))
    }
    box.anim.play("close", false)
    box.anim.setLastFrameCallFunc(function () {
        box.anim.clearLastFrameCallFunc()
        box.runAction(cc.CallFunc.create(function () {
            var leaf = self.getChildByName("leaf")
            var wPos = self.convertToWorldSpace(cc.p(leaf.getPosition()))
            var leafSprite = cc.Sprite.createWithSpriteFrameName("mark_panel/res_leaf.png")
            leafSprite.setScale(self.getScale() * leaf.getScale())
            leafSprite.setAnchorPoint(cc.p(0, 1))
            leafSprite.setPosition(wPos)
            self.getParent().addChild(leafSprite, 100)
            leafSprite.runAction(cc.Sequence.create(cc.DelayTime.create(0.2), cc.CallFunc.create(function () {
                PopoutManager.getInstance().removeWithBgFadeOut(self, cleanup, null, 0.32)
                PanelScaleAnim.remove(self, 0.2, cc.p(vSize.width / 2, vSize.height / 2))
                leafSprite.removeFromParent(true)
            })))
            box.retain()
            box.removeFromParent(true)
            box.setPosition(cc.p(from.x, from.y * self.getScale()))
            self.getParent().addChild(box)
            box.release()
            box.runAction(cc.Sequence.create(cc.Spawn.create(cc.EaseSineIn.create(cc.MoveBy.create(0.5, cc.p(to.x - from.x, 0))), cc.EaseBackIn.create(cc.MoveBy.create(0.5, cc.p(0, to.y - from.y))), cc.ScaleTo.create(0.5, scaleX, scaleY)), cc.CallFunc.create(function () {
                box.removeFromParent(true)
                if (callback) {
                    callback()
                }
            })))
        }))
    })
    return self
}
module.exports = table([0, MarkPriseWxChestPanel], [0, MarkPriseWxChestPanelEvent])
